import { useEffect, useState } from 'react';

// True only once `active` has held for `delayMs`. Used so a loading indicator
// never appears for a request that resolves quickly, which is what makes
// navigation look like it flashes.
export const useDelayedFlag = (active: boolean, delayMs = 250): boolean => {
  const [isElapsed, setIsElapsed] = useState(false);

  useEffect(() => {
    if (!active) {
      setIsElapsed(false);
      return;
    }

    const timer = setTimeout(() => setIsElapsed(true), delayMs);

    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return active && isElapsed;
};
